import React, { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from 'react-redux';

import { AuthContext } from "./Auth";
import { getAllProjects } from '../../services/database/Projects';
import { initProjects, initSplit } from "../../redux/reducers/ProjectsSlice";
import { getAllSplit } from "../../services/database/Splits";

const PrivateRoute = ({ children }) => {
    const dispatch = useDispatch();

    const { currentUser } = useContext(AuthContext);

    useEffect(() => {
        if (!!currentUser) {

            getAllProjects()
                .then(allProjects => {
                    dispatch(initProjects({ allProjects }))
                })

            getAllSplit()
                .then(allSplit => {
                    dispatch(initSplit({ allSplit }))
                })
        }
    }, [])

    return !!currentUser ? children : <Navigate to="/login" />;
};

export default PrivateRoute